import { createApp } from 'vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import App from './App.vue'
import router from './router'
import axios from 'axios';

const app = createApp(App);

app.use(ElementPlus).use(router).mount('#app')
app.config.globalProperties.$axios = axios;
